<script setup lang="ts">
import axios from 'axios'
import type { MerchantReviewManagerConfig } from '@/types/reviewPlatforms'
import DeliverooConfig from '../configuration/DeliverooConfig.vue'
import UberEatsConfig from '../configuration/UberEatsConfig.vue'

const { t } = useI18n()
const { user } = useLocalStorage()

const config = ref<MerchantReviewManagerConfig | null>(null)
const isLoading = ref(true)
const fetchError = ref(false)

async function fetchConfig() {
  isLoading.value = true
  fetchError.value = false
  try {
    const { data } = await axios.get(`/merchants/${user.value.merchant.id}/review-managers/config`)
    config.value = data.data ?? null
  } catch {
    fetchError.value = true
  } finally {
    isLoading.value = false
  }
}

onMounted(fetchConfig)
</script>

<template>
  <div class="flex flex-col gap-6">
    <Alert v-if="fetchError" variant="destructive">
      <AlertDescription>{{ t('pages.reviewPlatforms.configuration.fetchError') }}</AlertDescription>
    </Alert>
    <DeliverooConfig :config="config?.deliveroo" :is-loading="isLoading" @saved="fetchConfig" />
    <UberEatsConfig :config="config?.ubereats" :is-loading="isLoading" @saved="fetchConfig" />
  </div>
</template>
